@for (item of totals; track trackById($index, item); let first = $first) {
@if (item.id === 'total') {
@if (displayBasketDeliveryMethods) {
<basket-delivery-methods class="block m-t-2 m-b-2"
                         (methodSelected)="onDeliveryMethodSelected($event)" />
}
}

@if (item.id !== 'tax' || !displayBasketDeliveryMethods) {
<div class="flex flex-justify-between"
     [class.m-t]="!first && item.id === 'total'"
     [class.s1]="item.id === 'total'"
     [ngClass]="item.id === 'total' ? 's1 col-1 m-t-3 b-t p-t-3 b-col-4' : 'p1 col-11 m-t-2'">
    <label>{{ itemLabel(item) | translate }}</label>
    <price class="price p1"
           [useFreeLabel]="item.id === 'shipping'"
           [precision]="2"
           [value]="item.value"></price>
</div>
}
}